import { render, staticRenderFns } from "./questionnairetasktopic.vue?vue&type=template&id=7d6f92cc&"
import script from "./questionnairetasktopic.vue?vue&type=script&lang=js&"
export * from "./questionnairetasktopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports